import React from "react";
import CustomDropdown from "../../../components/input/CustomDropdown";

const SiteListRow = ({
  site,
  onRowClick,
  index,
  handleDropDownChange,
  onOpenSiteInfo,
}) => {
  return (
    <div className="rounded-[8px] w-[99%] h-[59px] min-h-[59px] bg-[#2B2B2B] pl-[30px] pr-[20px] flex text-white items-center cursor-pointer justify-between">
      {/* Site Info */}
      <div className="flex">
        <div className="w-Site_name flex items-center">{site.Site_name}</div>
        <div className="w-siteEmail flex items-center">
          {`${site.Site_contact_firstname || ""} ${
            site.Site_contact_lastname || ""
          }`}
        </div>
        <div className="w-siteEmail flex items-center">{site.Site_contact_email}</div>
        <div className="w-sitePhone flex items-center gap-2">
          {site.Site_contact_phone}
        </div>
        {/* Status Dropdown */}
        <div className="min-w-[124px] flex justify-space">
          <CustomDropdown
            variant="outlined"
            value={!!site.Enabled}
            onChange={(name, newValue) => {
              // Call with siteId and enabled status as expected by SiteListComp
              handleDropDownChange(site.Site_index, newValue);
            }}
            name="Enabled"
            className="font-white"
            label=""
            data={[
              { label: "Enabled", value: true },
              { label: "Disabled", value: false },
            ]}
          />
        </div>
      </div>

      {/* Actions (Info/Edit) */}
      <div>
        <CustomDropdown
          value={null}
          onChange={(name, newValue) => {
            switch (newValue) {
              case "info":
                onOpenSiteInfo(index);
                break;
              case "edit":
                onRowClick(index);
                break;
              default:
                console.log("Unknown action:", newValue);
            }
          }}
          name="Actions"
          hideArrow
          noOutline
          label=""
          icon={<span className="text-white text-xl leading-none">⋮</span>}
          data={[
            { label: "Info", value: "info" },
            { label: "Edit", value: "edit" },
          ]}
        />
      </div>
    </div>
  );
};

export default SiteListRow;
